import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBloomreachModel, getIsInAuthor, getSearchHistoryRootLangKey, } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { PixelEvent, setPixelEvent } from '@yme/utils/bloomreach';
import { SearchHistoryItem } from './SearchHistoryItem';
import { SearchListStyled, SearchHistoryWrapperStyled, SearchHistoryContentStyled, SearchHintStyled, DividerStyled, } from './styled';
import { useSearchKeyboardControl } from './useSearchKeyboardControl';
export function SearchHistory({ activeElement, isRightToLeft, isWrapper, searchResultsPageUrl, onClickLink, }) {
    const { t } = useTranslation();
    const searchHistoryKey = useSelector(getSearchHistoryRootLangKey);
    const { productCatalog } = useSelector(getBloomreachModel);
    const isInAuthor = useSelector(getIsInAuthor);
    const rawData = sessionStorage.getItem(searchHistoryKey);
    const searchHistoryDefault = rawData ? JSON.parse(rawData) : [];
    const [historyData, setHistoryData] = useState(searchHistoryDefault);
    const handleClickSearchEventLink = useCallback((query) => {
        if (!isInAuthor) {
            setPixelEvent(PixelEvent.SEARCH, {
                q: query,
                domain_key: productCatalog,
            });
        }
        onClickLink();
    }, [isInAuthor, onClickLink, productCatalog]);
    useSearchKeyboardControl({
        activeElement,
        listRef: null,
    });
    const listContent = historyData.map((historyItem, index) => {
        const isActive = activeElement === index;
        return (React.createElement(SearchHistoryItem, { key: historyItem, historyText: historyItem, historyData: historyData, setHistoryData: setHistoryData, isActive: isActive, searchResultsPageUrl: searchResultsPageUrl, handleClickLink: handleClickSearchEventLink }));
    });
    const SearchHistoryContent = (React.createElement(SearchHistoryContentStyled, { padding: "6px 0 6px 6px", flexDirection: "column", isFullWidth: true },
        React.createElement(SearchHintStyled, null, t('globalSearch_searchBarSymbolsAmount_hint')),
        historyData.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(DividerStyled, null),
            React.createElement(SearchListStyled, { isRightToLeft: isRightToLeft, isSearchHistory: true }, listContent)))));
    return isWrapper ? (React.createElement(SearchHistoryWrapperStyled, null, SearchHistoryContent)) : (SearchHistoryContent);
}
